import { IBuilding } from 'spw-redux/modules/projects/types';

export const buildingIndexesById = (buildings: IBuilding[]) => {
  return buildings
    .map((building, index) => {
      return {
        ...building,
        index,
      };
    })
    .reduce((map, building) => {
      return {
        ...map,
        [building.id]: building.index,
      };
    }, {});
};
